/* ============================================================
   YVETTE LUXE — v6 interactions
   No dependencies. Loaded with `defer` from layout/theme.liquid.

   1. Auto-hide header + compact bar
   2. Mobile drawer (Escape · click-outside · focus trap · scroll lock)
   3. Explore hover crossfade
   4. Sticky add-to-bag bar
   5. Two-stage fragrance -> add to bag (AJAX)
   6. Added-to-bag confirmation panel
   ============================================================ */
(function () {
  'use strict';

  var forEach = function (list, fn) { Array.prototype.forEach.call(list || [], fn); };
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function announce(msg) {
    var live = document.querySelector('[data-yv-live]');
    if (live) { live.textContent = ''; window.setTimeout(function () { live.textContent = msg; }, 60); }
  }

  /* ---------------------------------------------------------
     1. AUTO-HIDE HEADER + COMPACT BAR
     The tall header is position:sticky, so it occupies real
     layout space — no spacer, no layout shift. Past 50px it
     glides away. The compact bar slides in only on scroll UP.
     The 10px delta is hysteresis: without it, trackpad jitter
     flips direction every frame and the bar flickers.
     --------------------------------------------------------- */
  function initHeader() {
    var full = document.querySelector('[data-yv-header]');
    var mini = document.querySelector('[data-yv-mini]');
    if (!full && !mini) return;

    var THRESHOLD = 50, DELTA = 10;
    var last = window.pageYOffset || 0, dir = 'up', ticking = false;

    function update() {
      ticking = false;
      var y = window.pageYOffset || 0;
      var d = y > last ? 'down' : 'up';
      if (d !== dir && Math.abs(y - last) > DELTA) dir = d;
      last = y > 0 ? y : 0;

      var past = y > THRESHOLD;
      if (full) full.classList.toggle('is-hidden', past);
      if (mini) mini.classList.toggle('is-shown', past && dir === 'up');
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });

    update();
  }

  /* ---------------------------------------------------------
     2. MOBILE DRAWER
     Full-screen panel entering from the right. Unlike the live
     site's drawer this one closes on Escape, traps focus while
     open, locks body scroll, and returns focus to the burger.
     --------------------------------------------------------- */
  function initDrawer() {
    var burger = document.querySelector('[data-yv-burger]');
    var drawer = document.querySelector('[data-yv-drawer]');
    var scrim = document.querySelector('[data-yv-drawer-scrim]');
    if (!burger || !drawer) return;

    var open = false, scrollY = 0;

    function focusables() { return drawer.querySelectorAll(FOCUSABLE); }

    function setOpen(next) {
      if (next === open) return;
      open = next;
      drawer.classList.toggle('is-open', open);
      document.body.classList.toggle('yv-menu-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');

      if (open) {
        scrollY = window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.width = '100%';
        var f = focusables();
        if (f.length) f[0].focus();
      } else {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
        burger.focus();
      }
    }

    burger.addEventListener('click', function () { setOpen(!open); });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    forEach(document.querySelectorAll('[data-yv-drawer-close]'), function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') { setOpen(false); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------------------------------------------------------
     3. EXPLORE HOVER CROSSFADE
     Layers are already in the DOM with their images set in
     Liquid, so the section renders with JS disabled and the
     browser preloads all four. JS only swaps a class; the
     700ms crossfade is pure CSS.
     --------------------------------------------------------- */
  function initExplore() {
    forEach(document.querySelectorAll('[data-yv-explore]'), function (root) {
      var items = root.querySelectorAll('[data-yv-explore-item]');
      var bgs = root.querySelectorAll('[data-yv-explore-bg]');
      if (!items.length || !bgs.length) return;

      function activate(index) {
        forEach(items, function (el, n) { el.classList.toggle('is-active', n === index); });
        forEach(bgs, function (el, n) { el.classList.toggle('is-active', n === index); });
      }

      forEach(items, function (el, i) {
        el.addEventListener('mouseenter', function () { activate(i); });
        el.addEventListener('focus', function () { activate(i); });
      });

      activate(0);
    });
  }

  /* ---------------------------------------------------------
     4. STICKY ADD-TO-BAG
     Watches the REAL add-to-cart button rather than a scroll
     threshold, so the CTA is never duplicated on screen. Also
     watches the footer, so the bar retreats at the bottom.
     --------------------------------------------------------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-yv-sticky-atc]');
    var anchor = document.querySelector('[data-yv-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var stop = document.querySelector('[data-yv-atc-stop]');
    var atcVisible = true, stopVisible = false;

    function sync() { bar.classList.toggle('is-shown', !atcVisible && !stopVisible); }

    new IntersectionObserver(function (e) { atcVisible = e[0].isIntersecting; sync(); },
      { rootMargin: '0px 0px -12% 0px' }).observe(anchor);
    if (stop) new IntersectionObserver(function (e) { stopVisible = e[0].isIntersecting; sync(); }).observe(stop);
    sync();
  }

  /* ---------------------------------------------------------
     5 + 6. TWO-STAGE BUY AND CONFIRMATION PANEL
     Stage one: pick a fragrance. The CTA stays genuinely
     disabled and says why. Stage two: /cart/add.js, so the
     shopper never leaves the Creations page.
     --------------------------------------------------------- */
  var panel = {
    layer: null, box: null, openState: false, lastFocus: null,

    init: function () {
      this.layer = document.querySelector('[data-yv-panel-layer]');
      this.box = document.querySelector('[data-yv-panel]');
      if (!this.layer) return;
      var self = this;

      forEach(document.querySelectorAll('[data-yv-panel-close]'), function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      this.layer.addEventListener('click', function (e) {
        if (self.box && !self.box.contains(e.target)) self.close();
      });
      document.addEventListener('keydown', function (e) {
        if (self.openState && e.key === 'Escape') self.close();
      });
    },

    show: function (data) {
      if (!this.layer) return;
      var set = function (sel, val) {
        var el = document.querySelector(sel);
        if (el) el.textContent = val || '';
      };
      var img = document.querySelector('[data-yv-panel-img]');
      if (img) { img.src = data.image || ''; img.alt = data.title || ''; }
      set('[data-yv-panel-name]', data.title);
      set('[data-yv-panel-variant]', data.variant);
      set('[data-yv-panel-price]', data.price);

      this.lastFocus = document.activeElement;
      this.layer.classList.add('is-open');
      this.openState = true;
      announce((data.title || 'Item') + ' added to your bag');

      var close = this.layer.querySelector('[data-yv-panel-close]');
      if (close) close.focus();
    },

    close: function () {
      if (!this.layer || !this.openState) return;
      this.layer.classList.remove('is-open');
      this.openState = false;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }
  };

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        forEach(document.querySelectorAll('[data-yv-cart-count]'), function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { /* stale count is not worth failing the add over */ });
  }

  function initCards() {
    forEach(document.querySelectorAll('[data-yv-card]'), function (card) {
      var opts = card.querySelectorAll('[data-yv-opt]');
      var atc = card.querySelector('[data-yv-card-atc]');
      var priceEl = card.querySelector('[data-yv-card-price]');
      if (!atc) return;

      var chosen = atc.getAttribute('data-variant') || null;   // preset for single-variant products
      var chosenLabel = '';

      /* --- stage one: choose a fragrance --- */
      forEach(opts, function (opt) {
        opt.addEventListener('click', function () {
          forEach(opts, function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-pressed', 'false');
          });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-pressed', 'true');

          chosen = opt.getAttribute('data-variant');
          chosenLabel = opt.getAttribute('data-label') || '';
          if (priceEl) priceEl.textContent = opt.getAttribute('data-price') || priceEl.textContent;

          atc.disabled = false;
          atc.textContent = 'Add to bag';
        });
      });

      /* --- stage two: add without leaving the page --- */
      atc.addEventListener('click', function () {
        if (!chosen || atc.disabled) return;
        var restore = 'Add to bag';
        atc.disabled = true;
        atc.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(chosen), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () { return refreshCartCount(); })
          .then(function () {
            atc.textContent = restore;
            atc.disabled = false;
            panel.show({
              title: card.getAttribute('data-title'),
              image: card.getAttribute('data-image'),
              variant: chosenLabel,
              price: priceEl ? priceEl.textContent : ''
            });
          })
          .catch(function () {
            atc.textContent = 'Try again';
            atc.disabled = false;
            announce('Sorry, that could not be added to your bag.');
            window.setTimeout(function () { atc.textContent = restore; }, 2500);
          });
      });
    });
  }

  function boot() {
    initHeader();
    initDrawer();
    initExplore();
    initStickyAtc();
    panel.init();
    initCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ---------- v9.13 — FAQ search filter ---------- */
(function () {
  var input = document.querySelector('[data-yv-faq-search]');
  var list  = document.querySelector('[data-yv-faq-list]');
  if (!input || !list) return;
  var items = Array.prototype.slice.call(list.querySelectorAll('.yv-acc-item'));
  var empty = document.querySelector('[data-yv-faq-empty]');
  var wasOpen = items.map(function (d) { return d.open; });
  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function run() {
    var q = norm(input.value);
    var hits = 0;
    items.forEach(function (d, i) {
      if (!q) { d.classList.remove('yv-faq-hide', 'yv-faq-hit'); d.open = wasOpen[i]; hits++; return; }
      var hit = norm(d.textContent).indexOf(q) !== -1;
      d.classList.toggle('yv-faq-hide', !hit);
      d.classList.toggle('yv-faq-hit', hit);
      if (hit) { d.open = true; hits++; }
    });
    if (empty) empty.hidden = hits > 0;
  }
  input.addEventListener('input', run);
  input.addEventListener('search', run);
})();

/* policy pages: collapse the empty Word-paste paragraphs (<p>&nbsp;</p>) that live inside Settings → Policies */
(function () {
  var body = document.querySelector('.yv-policy .shopify-policy__body');
  if (!body) return;
  /* Shopify strips the pasted Word <style> tag but leaves its text behind — drop those text nodes */
  Array.prototype.slice.call(body.querySelectorAll('*')).concat([body]).forEach(function (el) {
    Array.prototype.slice.call(el.childNodes).forEach(function (n) {
      if (n.nodeType === 3 && /mso-|Style Definitions|List Definitions/.test(n.textContent)) n.parentNode.removeChild(n);
    });
  });
  Array.prototype.slice.call(body.querySelectorAll('p, div')).forEach(function (el) {
    if (!el.children.length && el.textContent.replace(/[\s\u00a0]/g, '') === '') el.remove();
  });
})();

/* about film: make sure the muted loop actually starts (Safari/iOS can leave it paused) */
(function () {
  var v = document.querySelector('video.yv-about-film');
  if (!v) return;
  var kick = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
  v.addEventListener('loadedmetadata', kick);
  v.addEventListener('canplay', kick);
  if (v.readyState >= 1) kick();
  /* Low Power Mode / strict autoplay settings: a tap on the film starts it */
  v.addEventListener('click', function () { if (v.paused) kick(); else v.pause(); });
  var io = 'IntersectionObserver' in window && new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting && v.paused) kick(); });
  }, { threshold: 0.25 });
  if (io) io.observe(v);
})();
